module.exports = __webpack_public_path__ + "img/ded17155208738eb957fa2433f9eb454.ded17155.png";